import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-file-download-in-progress',
    templateUrl: './file-download-in-progress.component.html',
    styleUrls: ['./file-download-in-progress.component.scss'],
    standalone: false
})
export class FileDownloadInProgressComponent {

  @Input() loader: boolean;

}
